export function buildMintDocId(name) {
  const slug = String(name || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  return slug || 'mint';
}

export function normalizeMinterDocs(docs) {
  return docs
    .map((minterDoc) => {
      const data = typeof minterDoc.data === 'function' ? minterDoc.data() : minterDoc;
      const uid = minterDoc.id || data.uid || '';
      const name = String(data.name || data.mint || '').trim();

      return {
        uid,
        ...data,
        name,
      };
    })
    .filter((minter) => minter.name)
    .sort((left, right) => left.name.localeCompare(right.name));
}

export function buildMintOptions(minters, selectedMint = '') {
  const names = minters.map((minter) => String(minter.name || '').trim()).filter(Boolean);

  const uniqueNames = [...new Set(names)].sort((left, right) => left.localeCompare(right));
  const currentMint = String(selectedMint || '').trim();

  if (currentMint && !uniqueNames.includes(currentMint)) {
    uniqueNames.unshift(currentMint);
  }

  return uniqueNames;
}
